export default __webpack_public_path__ + "static/media/Icon_Null.d97eb9e7.svg";